export const faqs = [
    {
        question: "1. Can I be identified through my phone number or email address when I make a report?",
        answer: `No. The KPMG Ethics Line cannot view your number when you call the hotlines because the
        caller ID is not displayed. A whistleblower may choose to create an anonymous email account
        for the purpose of contacting KPMG Ethics Line. However, the whistleblower is encouraged to
        check the account from time to time as feedback from KPMG Ethics Line will be communicated to him/her via the email account.`
    },

    {
        question: `2. Why should I make a report?`,
        answer: `You should make a report because the fraudulent/unethical activities could affect you. Certain
        fraudulent activities lead to loss of resources and customers for many businesses and this will negatively affect the working environment and the continuity of the business (depending on the circumstance).`
    },
    {
        question: `3. How can I be sure that my identity will be protected?`,
        answer: `In addition to the absence of Caller ID technology which does not reveal your phone number to
        KPMG, you are not required to give your name or any personal details unless it is absolutely
        pertinent to the investigation that will be carried out on your report. In such a case, your
        express approval will be obtained before your identity is disclosed to the recipients of our
report on your complaint.`

    },
    {
        question: `4. How do I know that making reports via the KPMG Ethics Line will be effective?`,
        answer: `The KPMG Ethics Line has been operating for over a decade and our commitment is to serve
        our clients in line with leading practice. We intend to keep this service successful. Reports made
        via the KPMG Ethics Line are investigated and where a whistleblower requires feedback, KPMG
        will provide the feedback as long as the unique Reference Number to the complaint is provided
by the Whistleblower.`
    },
    {
        question: `5. What do I do with the Reference Number usually given after making a report?`,
        answer: `The Reference Number given after a report is a unique identifying number made for the
        purpose of that report. The whistleblower is to quote this number when calling for feedback or
to provide additional information on a report earlier made.`
    },
    {
        question: `6. Can I get a specific date for when my issue will be resolved?`,
        answer: `KPMG Ethics Line provides an independent whistleblowing service that serves as a safe and
        secure medium for concerned parties to report unhealthy work environment practices and
        unethical activities to the right level of management and board of directors at the organization
        involved. Consequently, the investigation and feedback on reports will be provided to
whistleblowers as soon as we obtain same from the organization.`
    },
    {
        question: `7. Can I make a report in person to the KPMG Ethics Line?`,
        answer: `No, the KPMG Ethics Line will only receive reports via our designated platforms. That is: our
        hotlines, mailbox, voice mail box, mobile app, webform and website.`
    },
    {
        question: `8. Will the Client be able to access recordings of my call to the KPMG Ethics Line?`,
        answer: `No! Your anonymity and safety areis paramount to our continued delivery of this service. The
        client will only receive reports sent from the KPMG Ethics Line which is carefully worded
protect the identity of the whistleblower.`
    }

]